/**
 * Format a date string to DD/MM/YYYY HH:MM format
 * @param {string} dateString - The date string to format
 * @returns {string} - Formatted date string or original string if invalid
 */
export function formatDate(dateString) {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${day}/${month}/${year} ${hours}:${minutes}`;
}

/**
 * Format a date string to MM/DD/YYYY HH:MM format (US format)
 * @param {string} dateString - The date string to format
 * @returns {string} - Formatted date string or original string if invalid
 */
export function formatDateUS(dateString) {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${month}/${day}/${year} ${hours}:${minutes}`;
}

/**
 * Format a date string to YYYY-MM-DD HH:MM format
 * @param {string} dateString - The date string to format
 * @returns {string} - Formatted date string or original string if invalid
 */
export function formatDateISO(dateString) {
    if (!dateString) return '';
    
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    
    return `${year}-${month}-${day} ${hours}:${minutes}`;
}

/**
 * Get current date and time in the specified format
 * @param {string} format - The format to use ('DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD')
 * @returns {string} - Current date and time formatted
 */
export function getCurrentDateTime(format = 'DD/MM/YYYY') {
    const now = new Date();
    
    const day = now.getDate().toString().padStart(2, '0');
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const year = now.getFullYear();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    
    switch (format) {
        case 'MM/DD/YYYY':
            return `${month}/${day}/${year} ${hours}:${minutes}`;
        case 'YYYY-MM-DD':
            return `${year}-${month}-${day} ${hours}:${minutes}`;
        default:
            return `${day}/${month}/${year} ${hours}:${minutes}`;
    }
} 